import { createSelector } from 'reselect';
import { getFileInfoState } from './getFileInfoState';
import { isArrayNullOrEmpty } from "../../common";
export const isFileStateEmpty = createSelector([getFileInfoState], (state) => {
    return !state || isArrayNullOrEmpty(state.allIds);
});
//# sourceMappingURL=isFileStateEmpty.js.map